import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appSpawner]',
})
export class SpawnerDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}
